export default import.meta.ROLLDOWN_FILE_URL_iLxS2BybQgfN$A5IDvQgVA